import axios from 'axios'
import authService from './authService'

let api = axios.create({
  baseURL: process.env.apiBaseUrl
})

// before sending request, change config if necessary
api.interceptors.request.use(function (config) {
  // if __noToken in config => do not change the config
  if (config.__noToken) {
    return config
  }

  // else, try to get the current token or a new one
  return new Promise((resolve, reject) => {
    config.params = config.params || {}

    let p = authService.getToken()
    p.then((token) => {
      config.params.oauth_token = token
      resolve(config)
    }).catch(() => {
      // if no token and __canHaveNoToken is defined in config, return unchanged config
      if (config.__canHaveNoToken) {
        return resolve(config)
      }
      // otherwise, reject call
      reject(config)
    })
  })
})

api.getTokenUrlParam = function () {
  return new Promise((resolve, reject) => {
    authService.getToken().then((token) => {
      resolve('oauth_token=' + token)
    }).catch(reject)
  })
}

api.getLastTokenUrlParam = function () {
  return 'oauth_token=' + authService.getLastToken()
}

api.getUrl = function (fragment, withToken = true) {
  if (!withToken) {
    return process.env.apiBaseUrl + fragment
  }
  return new Promise((resolve, reject) => {
    api.getTokenUrlParam().then((param) => {
      resolve(process.env.apiBaseUrl + fragment + '?' + param)
    })
  })
}

export default api



// WEBPACK FOOTER //
// ./src/utils/api.js